import api from 'utils/api';

export const endpoints = {
  sellers: {
    list: slug => `/sellers/${slug}/communication/banners/`,
    interactions: {
      create: slug => `/sellers/${slug}/communication/interactions/`,
    },
  },
  institutions: {
    list: slug => `/institutions/${slug}/communication/banners/`,
    interactions: {
      create: slug => `/institutions/${slug}/communication/interactions/`,
    },
  },
};

/**
 * Documentation:
 * Sellers: https://eskolare.postman.co/workspace/Eskolare-APIs~33e9d0fe-9d33-47cf-ad90-a76a685364de/request/2024076-ad262d28-0215-46e6-9e12-8052065acc9c
 * Institutions: https://eskolare.postman.co/workspace/Eskolare-APIs~33e9d0fe-9d33-47cf-ad90-a76a685364de/request/2024076-0cdfa977-f675-4a60-90fc-b53362bc0097
 */
export function sendInteraction({ type, slug, objectUid, action }) {
  const url = endpoints[type]?.interactions?.create(slug);
  const config = {
    method: 'post',
    url,
    data: { contentType: 'banner', objectUid, action },
  };
  return api(config);
}
